<template>
    <div class="team-col">
        <!-- <router-link @click="scrollToTop()" :to="`/team-lid/${activeMember}`"> -->
            <div class="member-card">
                <img :src="require(`../assets/images/${image}`)"
            :style="[activeMember == 'milad-rahatianpur' || activeMember == 'collega-milad' || activeMember == 'christine-mondhygienste'  || activeMember == 'miranda-klein' || activeMember == 'cecile-van-beijnen' || activeMember == 'danee-maenen' || activeMember == 'patty-van-gogh' || activeMember == 'hosniya-qaderi' || activeMember == 'melike-yilmaz' ?  {'object-fit': 'cover'}: '']">
            <!-- <img src="../assets/images/ali-al-saady.jpg"> -->
            <h3>{{ name }}</h3>
            <span v-html="branche"></span>
            </div>

        <!-- </router-link> -->
    </div>
</template>

<script>
export default {
name: "MemberCard",
props: {
    name: {
        type: String,
        default: 'ALI AL-SAADY'
    }, 
    branche: {
        type: String,
        default: 'VESTIGING DEN HAAG'
    },
    image: {
        type: String,
        default: 'milad-rahatianpur.jpg'
    },
    activeMember: {
        type: String,
        default: 'ali-al-saady'
    }
},
methods: {
scrollToTop() {
      window.scrollTo(0,0);
  }
}
}
</script>

<style scoped>
.team-col {
    flex-basis: 31%;
    background: #FFF3F3;
    border-radius: 10px;
    box-sizing: border-box;
    transition: 0.5s;
    /* cursor: pointer; */
    max-width: 375px;
}
/* .team-col:hover {
    box-shadow: 0 0 20px 0px rgba(0,0,0,0.2);
    transform: translateY(-3px);
} */
.team-col a {
    text-decoration: none;
    display: block;
    padding: 43px 40px 35px;
}
.team-col a h3{
    color: #000000;
    padding-top: 25px;
    padding-bottom: 0px;
}
.team-col a span{
    color: #606060;
    font-size: 14px;
}

.team-col .member-card {
    text-decoration: none;
    display: block;
    padding: 43px 40px 35px;
}
.team-col .member-card h3{
    color: #000000;
    padding-top: 25px;
    padding-bottom: 0px;
}
.team-col .member-card span{
    color: #606060;
    font-size: 14px;
}
.team-col img {
    width: 200px;
    height: 270px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Bredere styling voor no-picture placeholder */
.team-col img[src*="no-picture.png"] {
    width: 250px;
    height: 270px;
    object-fit: contain;
    background-color: #f8f8f8;
    padding: 10px;
}
@media(max-width: 991px) {
.team-col {
    max-width: 300px;
    margin: auto;
    margin-bottom: 40px;
 }
 
 /* Aangepaste mobiele styling voor no-picture placeholder */
 .team-col img[src*="no-picture.png"] {
    width: 220px;
    height: 240px;
 }
}
</style>